import apiCall from "../axios/apiCall";

const controller = "informacion_general";

export default {
    getGeneralInformation: async () => {
        let response = { success: true };
        const method = ``;
        try {
            const apiResponse = await apiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = apiCall.handleCatch(error);
        }
        return response;
    },
    updateGeneralInformation: async (data) => {
        let response = { success: true };
        const method = ``;
        try {
            const apiResponse = await apiCall.put(controller, method, data);
            response.message = apiResponse?.data;
        } catch (error) {
            response = apiCall.handleCatch(error);
        }
        return response;
    },
}